import { LIST_USERS } from '../config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case LIST_USERS:
            return action.payload;
        default:
            return state;
    }
}

export default reducer;